import { render, staticRenderFns } from "./verifyMembership.vue?vue&type=template&id=89a94154&scoped=true"
import script from "./verifyMembership.vue?vue&type=script&lang=js"
export * from "./verifyMembership.vue?vue&type=script&lang=js"
import style0 from "./verifyMembership.vue?vue&type=style&index=0&id=89a94154&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a94154",
  null
  
)

export default component.exports